import { Component, OnInit } from '@angular/core';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { Router } from '@angular/router';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { RecommendationModel } from 'projects/core/src/lib/models/recommendation.model';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-recommendation-list',
  templateUrl: './recommendation-list.component.html',
  styleUrls: ['./recommendation-list.component.scss']
})
export class RecommendationListComponent extends BaseList implements OnInit {

  public recommendations: Array<RecommendationModel> = [];

  protected rightLoad = 'admin.recommendation.list';
  protected rightNew = 'admin.recommendation.create';
  protected rightOpen = 'admin.recommendation.show';

  protected apiUrl = '/recommendations';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected auth: AuthStateService,
    public transloco: TranslocoService
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.ui.setPageTitle(this.transloco.translate('common.labels.recommendations'));
    this.loadList();
  }

  loadList(): void {
    this.loading = true;
    this.api.getModels('recommendations').subscribe({
      next: (recommendations: any) => {
        this.recommendations = [];
        recommendations.data.forEach((recommendation: any) => {
          this.recommendations.push(new RecommendationModel().deserialize(recommendation));
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

}
